import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rk-radio-button',
  standalone: false,
  templateUrl: './radio-button.component.html',
  styleUrl: './radio-button.component.scss',
})
export class RadioButtonComponent {
  @Input() value: any;
  @Input() label = '';
  @Input() name = '';
  @Input() checked = false;
  @Input() disabled = false;

  @Output() readonly selectionChange = new EventEmitter<any>();

  onSelectionChange() {
    if (!this.disabled) {
      this.selectionChange.emit(this.value);
    }
  }
}
